import { motion } from "framer-motion";
import { Moon } from "lucide-react";

interface NightSelectorProps {
  selectedNight: number;
  onSelectNight: (night: number) => void;
}

const NIGHTS = [21, 22, 23, 24, 25, 26, 27, 28, 29, 30];

export const NightSelector = ({ selectedNight, onSelectNight }: NightSelectorProps) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="space-y-3"
    >
      <h2 className="text-xs uppercase tracking-[0.2em] text-gold flex items-center gap-3">
        <Moon className="w-4 h-4" />
        Select Night
      </h2>
      <div className="flex flex-wrap gap-2">
        {NIGHTS.map((night) => {
          const isOdd = night % 2 !== 0;
          const isSelected = selectedNight === night;
          return (
            <button
              key={night}
              onClick={() => onSelectNight(night)}
              className={`relative px-3 py-2 rounded-sm text-xs transition-all ${
                isSelected
                  ? "bg-gold/20 text-gold border border-gold/40 font-medium"
                  : isOdd
                    ? "border border-gold/15 text-cream/60 hover:border-gold/30 hover:text-cream/80"
                    : "border border-cream/10 text-cream/40 hover:border-cream/20 hover:text-cream/60"
              }`}
            >
              {night}
              {isOdd && !isSelected && (
                <span className="absolute -top-1 -right-1 w-1.5 h-1.5 bg-gold/50 rounded-full" />
              )}
            </button>
          );
        })}
      </div>
      <p className="text-cream/30 text-[10px]">
        ✦ Odd nights are highlighted — seek Laylatul Qadr among them
      </p>
    </motion.div>
  );
};
